export default "__VITE_ASSET__C81f6TUf__"